import ProjectRow from './ProjectRow';
import { FolderOpen } from 'lucide-react';

export default function ProjectList({ projects, loading, onDelete, onEdit, onCreateNew }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 dark:border-emerald-500 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading projects...</p>
        </div>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4">
        <div className="w-16 h-16 bg-gray-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4">
          <FolderOpen className="w-8 h-8 text-gray-400 dark:text-gray-500" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">No projects yet</h3>
        <p className="text-gray-600 dark:text-gray-400 text-center mb-6 max-w-md">
          Create your first project to start organizing and redacting your documents.
        </p>
        <button
          onClick={onCreateNew}
          className="px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition font-medium"
        >
          Create First Project
        </button>
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200 dark:divide-dark-border">
      {projects.map((project) => (
        <ProjectRow
          key={project.id}
          project={project}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </div>
  );
}
